'use strict';

/**
 *
 * @name: campaignTrackingServ
 *
 */

function campaignTrackingFactory() {

  'ngInject';

  function generateTrackingParams(source, medium, campaign) {

    if (!source || !medium || !campaign) {

      throw new Error('To generate campaign code source, medium, campaign are required!');
    }

    return 'utm_source=' + source + '&utm_medium=' + medium + '&utm_campaign=' + campaign;
  }

  return {
    generateTrackingParams: generateTrackingParams
  };
}

export default campaignTrackingFactory;



// WEBPACK FOOTER //
// ./app/components/nn-analytics/nn-campaign-tracking.factory.js